import { enc, MD5 } from "crypto-js";
import moment from "moment";
import { crypto, cryptoSha256, descEncrypt } from "app/shared/util/pcrypto";

export const createSessionId = () => {
  const session_id = Math.floor(Math.random() * 100) + 1 + moment().valueOf().toString();
  const md5_str = MD5(session_id).toString(enc.Hex);
  return md5_str;
};

export const encryption = async (userId: string = "", value: string = "") => {
  let encUserId: string = "",
    encPassword: string = "",
    encPassword2: string = "";
  if (userId) {
    encUserId = descEncrypt(userId);
    encPassword = await crypto(userId, value);
    encPassword2 = await cryptoSha256(userId, value);
  }
  return { encUserId, encPassword, encPassword2 };
};
